export const stockType = {
  saham: 'saham',
  right: 'right',
  waran: 'waran',
  index: 'index',
  index_asing: 'index_asing',
  reksadana: 'reksadana',
  commodities: 'commodities',
  crypto: 'crypto',
  fx: 'fx',
  etf: 'etf',
};

export const expiryOption: string[] = ['Good For Day', 'Good Till Cancelled'];

export const triggerPriceOption: string[] = ['≥', '≤'];
export const lotSize = 100; // number of shares per lot

export const DATA_CY_MODAL_TRADING = {
  HEADER_TITLE: 'trading-modal-header-title',
  HEADER_CHANGE_EMITEN_BUTTON_PENCIL: 'trading-modal-emitten-button-pencil',
  HEADER_SEARCH_COMPANY: 'trading-modal-header-search-company',
  ORDER_TYPE_BUTTON_INFO: 'trading-modal-order-type-button-info',
  ORDER_TYPE_SELECT: 'trading-modal-order-type-select',
  ORDER_TYPE_SELECT_DROPDOWN: 'trading-modal-order-type-select-dropdown',
  FORM_TRIGGER_PRICE: 'trading-modal-form-trigger-price',
  TRIGGER_PRICE_BUTTON_INFO: 'trading-modal-trigger-price-button-info',
  TRIGGER_PRICE_SELECT: 'trading-modal-trigger-price-select',
  FORM_PRICE: 'trading-modal-form-price',
  FORM_BUY_PRICE: 'trading-modal-form-buy-price',
  FORM_LOT: 'trading-modal-form-lot',
  EXPIRY_SELECT: 'trading-modal-expiry-select',
  EXPIRY_SELECT_DROPDOWN: 'trading-modal-expiry-select-dropdown',
  BUTTON_PLACE_ORDER: 'trading-modal-button-place-order',
  AVAILABLE_LOT_VALUE: 'trading-modal-available-lot',
  FORM_SELL_ORDER_LOT: 'trading-modal-form-sell-order-lot',
  PROFIT_LOSS_VALUE: 'trading-modal-profit-loss',
};
